import React from 'react';
import PropTypes from 'prop-types';
import { ArrowRight } from 'lucide-react';
import { getSubjectName } from '../../../utils/subjectUtils';

const QuizOverview = ({ content, onStart, onClose }) => {
  const formatTimeLimit = (seconds) => {
    if (seconds <= 0) return '制限なし';
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return minutes > 0 
      ? `${minutes}分${remainingSeconds > 0 ? `${remainingSeconds}秒` : ''}`
      : `${seconds}秒`;
  };

  return (
    <div className="bg-white p-6 rounded-lg">
      <h3 className="text-2xl font-semibold text-purple-800 mb-6">{content.title}</h3>
      
      {/* クイズの基本情報 */}
      <div className="space-y-4 mb-8">
        <div className="bg-purple-50 p-4 rounded-lg">
          <h4 className="font-semibold text-purple-700 mb-2">クイズの概要</h4>
          <ul className="space-y-2 text-gray-700">
            <li>• 教科: {getSubjectName(content.subject)}</li>
            <li>• 問題数: {content.quizzes ? Object.keys(content.quizzes).length : 0}問</li>
            {content.timeLimitPerQuestion > 0 && !content.freeNavigation && (
              <li>• 1問あたりの制限時間: {formatTimeLimit(content.timeLimitPerQuestion)}</li>
            )}
            {content.freeNavigation && content.timeLimitPerContent > 0 && (
              <li>• 全体の制限時間: {formatTimeLimit(content.timeLimitPerContent)}</li>
            )}
          </ul>
        </div>

        {/* クイズのルール説明 */}
        <div className="bg-yellow-50 p-4 rounded-lg">
          <h4 className="font-semibold text-yellow-700 mb-2">ルール</h4>
          <ul className="space-y-2 text-gray-700">
            <li>• 問題の移動: {content.freeNavigation ? '自由に行き来可能' : '一方向のみ'}</li>
            <li>• 解答の表示: {content.answerRevealMode === 'immediate' ? '回答直後に表示' : '全問終了後にまとめて表示'}</li>
            
            <li>• 回答方式: {content.quickAnswerMode === 'quick' 
      ? 'クイック回答（選択と同時に回答確定）' 
      : '標準回答（回答ボタンで確定）'}
      {content.quickAnswerMode === 'quick' && ' - 四択・正誤問題のみ'}
    </li>
            
            
            {content.randomizeQuizzes && (
              <li>• 問題はランダムな順序で出題されます</li>
            )}
          </ul>
        </div>
      </div>

      {/* ボタン群 */}
      <div className="flex justify-end gap-4">
        <button
          onClick={onClose}
          className="px-6 py-2 text-gray-600 hover:text-gray-800 rounded-lg"
        >
          キャンセル
        </button>
        <button
          onClick={onStart}
          className="px-6 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center gap-2"
        >
          <ArrowRight size={20} />
          スタート
        </button>
      </div>
    </div>
  );
};

QuizOverview.propTypes = {
  content: PropTypes.object.isRequired,
  onStart: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default QuizOverview; 